var _defs, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhnNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 2592 2880",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 1440,
    r: 1305.29,
    style: {
      fill: "#231f20"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 1440,
    r: 1061.51,
    className: "cls-2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 1440,
    r: 833.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m743.31 1828.2-115.75-576.28 84.68-17.05 146.06 226.89c30.18 48.18 74.13 116.76 103.31 168.79l1.7-.38c-19.07-72.74-42-160.58-62.83-264.08l-32.65-162.42 80.39-16.16L1064 1763.86l-84.62 17L832.53 1555c-31.19-48.94-70.72-113-99.2-170.5l-1.64.38c16.79 66 36.5 146.56 60.56 266.29l32.26 160.71ZM1340.78 1435.17l-136.87 27.41 36.75 183.06 155.69-31.26 16 79.51-247.2 49.63-115.81-576.35 236.93-47.61 15.91 79.56-145.38 29.18 31.82 158.25 136.85-27.55ZM1559.52 1664.33 1339.45 1109l94.85-19.07 88.22 243.88c23.11 66.49 43.19 131 65.1 200.43l2.59-.57c-6.88-74.26-6.63-139.24-8-212.81L1578 1061l75.27-15.09 94.09 238.19c25.38 64.29 49.38 126.17 72.81 203.34l1.77-.38c-7.46-81.27-11.24-144.55-16.11-212.94l-12.37-256.44 89-17.87 9.73 597.69-93.21 18.7-89.86-221.2c-21.72-55.32-44.2-118.34-64.47-183.7l-1.65.32c4.11 69.46 6.57 134.82 6.64 197.08l-1.2 237.75Z",
    className: "cls-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhnNew);
export default __webpack_public_path__ + "static/media/phnNew.2325e771dbacd4ee7fae31be0c3ae616.svg";
export { ForwardRef as ReactComponent };